/**
 * Orders items by how often they have actually been used, most-used first.
 *
 * This is the alternative to two things that both look reasonable and are
 * both wrong for the phone quick-entry pickers: alphabetical order (tells you
 * nothing about which vendor a visitor is actually likely to pick) and a
 * hardcoded "top vendors" guess (goes stale the moment the tenant's real
 * usage shifts, and nobody remembers to update it). Counts come from the
 * tenant's own entry history — see `hooks/useUsageCounts.ts`.
 *
 * A STABLE sort: items tied on count — the common case is "everything tied
 * at 0" before any real traffic exists for a tenant — keep whatever relative
 * order the caller passed in (the API's own order: name for vendors, account
 * number for accounts) rather than being shuffled by tie-break logic nobody
 * asked for. `Array.prototype.sort` has been spec-guaranteed stable since
 * ES2019, so this is relied on rather than hand-rolled.
 */
export function orderByUsage<T extends { id: string }>(
  items: readonly T[],
  counts: ReadonlyMap<string, number>,
): T[] {
  return [...items].sort((a, b) => (counts.get(b.id) ?? 0) - (counts.get(a.id) ?? 0));
}
